// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, fetchApiData, roundPrice } from '../../../fnc.js'
import { error } from "jquery";
import Chart from 'chart.js/auto';
import moment from 'moment';
const refConst = require("../../../constants.js").v

const hasReviewedQuantity = item => item.qty_adjusted !== undefined && item.qty_adjusted !== null && item.qty_adjusted !== '';
const getFinalOrderQuantity = item => {
	const requested = Math.max(0, Number(hasReviewedQuantity(item) ? item.qty_adjusted : item.recommended_order) || 0);
	const increment = Math.max(1, Number(item.reorder_in_qty_of) || 1);
	return requested > 0 ? Math.ceil(requested / increment) * increment : 0;
};

export default function PoShowListItems(props){

	const initialState = {
		version: "0.1.0",
		poItems: null,
		salesHistory: null
	}

	const refModalAssignedTo = useRef(null);
	const [version, setVersion] = useState(initialState.version);
	const [poItems, setPoItems] = useState(initialState.poItems);
	const [skuSearch, setSkuSearch] = useState("");
	const [editQty, setEditQty] = useState(null);
	const [refreshView, setRefreshView] = useState(0);
	const [salesHistory, setSalesHistory] = useState(null);
	const [chart, setChart] = useState(null);
	const [skuSelectedForGraph, setSkuSelectedForGraph] = useState(null);
	const [ongoingPoItems, setOngoingPoItems] = useState(null);
	const [filteredSalesHistory, setFilteredSalesHistory] = useState(null);
	const [filteredPoItems, setFilteredPoItems] = useState(null);
	const [po, setPo] = useState(null);
	const [lastPo, setLastPo] = useState(null);

	useEffect(() => {
		if(props.parent.match.params.idSupplier){
			init()
		}
	}, [props.parent.match.params.idSupplier])

	useEffect(() => {

		if(!filteredSalesHistory || !refConst.stores) return;
		let labelBottom = [];
		let itemsGraphData = {};
		let colorsList = [];
		/**
		 * salesHistory = [
		 * 	2025-03-28: 7,
		 * 	2025-03-29: 136,
		 * 	2025-03-30: 33,
		 * 	2025-03-31: 19,
		 * 	2025-04-01: 13
		 * ]
		 */

		let listStoreNamePerId = {};
		refConst.stores.map(obj => {
			listStoreNamePerId[obj.id] = obj.name;
			colorsList.push(obj.color)
		})

		// console.info("filteredSalesHistory", filteredSalesHistory);

		// Create the date group base on the filters
		let dateType = 'days'
		let historyGrpBy = 6

		let firstLoop = true;

		for (const idStore in filteredSalesHistory.stores) {
			if (Object.prototype.hasOwnProperty.call(filteredSalesHistory.stores, idStore)) {

				let date = moment()

				if(!itemsGraphData[idStore])
					itemsGraphData[idStore] = [];

				for (let i = 180; i > 0; i--) {
					let dates = filteredSalesHistory.stores[idStore].sales_by_date;
					let dateF = date.format('YYYY-MM-DD')
					if(firstLoop)
						labelBottom.push(dateF)

					if(dateF in dates){
						itemsGraphData[idStore].push(dates[dateF])
					}else{
						itemsGraphData[idStore].push(0)
					}
					date = date.subtract(1, dateType);
				}
				if(firstLoop){
					firstLoop = false;
				}
				itemsGraphData[idStore] = itemsGraphData[idStore].reverse()
			}
		}

		labelBottom = labelBottom.reverse()
		/* console.info("itemsGraphData", itemsGraphData);
		console.info("labelBottom", labelBottom); */

		if(chart)
			chart.destroy()
		if(document.querySelector("#ctnChart"))
			setChart(new Chart(document.querySelector("#ctnChart"), {
				type: 'line',
				data: {
					labels: labelBottom,
					datasets: Object.keys(itemsGraphData).map((idStore, i) => {
						return {
							label: listStoreNamePerId[idStore],
							data: itemsGraphData[idStore],
							fill: false,
							cubicInterpolationMode: 'monotone',
							borderColor: colorsList[i],
							backgroundColor: colorsList[i],
							tension: 0.4
						}
					}),
				},
				options: {
					plugins: {
						legend: {
							align: 'center',
							/* labels: {
								filter: filtersFnc
							} */
						},
						tooltips: {
							mode: 'index',
							intersect: false,
							callbacks: {
								label: function(tooltipItem, data) {
									var label = data.datasets[tooltipItem.datasetIndex].label;
									var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
									return label + ': ' + new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);  // Format the label and value here
								}
							}
						}
					},
					// aspectRatio: props.doubled && props.inlineView? 3 : 2,
					aspectRatio: 3,
					/* elements: {
						line: {
							tension: 0.4  // Set this to the desired line tension
						}
					}, */
					scales: {
						y: {
							ticks: {
								callback: function(value, index, values) {
									if(value >= 1000){
										return value / 1000 + 'k';
									} else {
										return value;
									}
								},
								autoSkip: true,
								maxTicksLimit: 5
							}
						},
						x: {
							ticks: {
								autoSkip: true,
								maxTicksLimit: [180, 365].indexOf(180) !== -1? historyGrpBy : 7,
								callback: function(value, index, values) {
									// Format the value here and return it
									/* console.info("valuevalue", value);
									console.info("indexindex", index);
									console.info("valuesvalues", values); */
									return moment(labelBottom[index]).format('MMM D YY');
								}
								// max: labelBottom[0],
							}
						}
					},
					interaction: {
						mode: 'index',
						intersect: false
					},
					spanGaps: true,
				}
			}))
	}, [filteredSalesHistory, refConst.stores])

	// Filter salesHistory based on ongoingPoItems
	useEffect(() => {
		if (salesHistory && ongoingPoItems) {
			filterSalesHistoryWithOngoingPo();
		} else if (salesHistory) {
			// If we have salesHistory but no ongoingPoItems, use original data
			setFilteredSalesHistory(salesHistory);
		}
	}, [salesHistory, ongoingPoItems])

	// Filter poItems based on ongoingPoItems
	useEffect(() => {
		if (poItems && ongoingPoItems) {
			filterPoItemsWithOngoingPo();
		} else if (poItems) {
			// If we have poItems but no ongoingPoItems, use original data
			setFilteredPoItems(poItems);
		}
	}, [poItems, ongoingPoItems])

	let filterPoItemsWithOngoingPo = () => {
		if (!poItems || !ongoingPoItems) return;

		console.info("Filtering poItems with ongoingPoItems", { poItems, ongoingPoItems });

		// Create a filtered copy of poItems
		let filtered = poItems.map(item => ({ ...item }));

		// For each PO item, find matching ongoing PO items and subtract quantities
		filtered = filtered.map(item => {
			if (item.sku) {
				// Find ongoing PO items that match this SKU
				const matchingOngoingItems = ongoingPoItems.filter(ongoingItem => 
					ongoingItem.sku === item.sku
				);

				if (matchingOngoingItems.length > 0) {
					// Calculate total ongoing quantity for this SKU
					const totalOngoingQty = matchingOngoingItems.reduce((sum, ongoingItem) => 
						sum + parseInt(ongoingItem.qty || 0), 0
					);

					console.info(`SKU ${item.sku}: recommended ${item.recommended_order}, ongoing ${totalOngoingQty}`);

					// Subtract ongoing quantity from recommended order
					const adjustedRecommendedOrder = Math.max(0, (item.recommended_order || 0) - totalOngoingQty);
					
					return {
						...item,
						recommended_order: adjustedRecommendedOrder,
						original_recommended_order: item.recommended_order, // Keep original for reference
						ongoing_po_qty: totalOngoingQty,
						has_ongoing_po: true
					};
				}
			}
			return {
				...item,
				ongoing_po_qty: 0,
				has_ongoing_po: false
			};
		});

		// Optionally, filter out items where recommended_order becomes 0 or negative
		// filtered = filtered.filter(item => item.recommended_order > 0);

		console.info("Filtered poItems result", filtered);
		setFilteredPoItems(filtered);
	}

	let filterSalesHistoryWithOngoingPo = () => {
		if (!salesHistory || !ongoingPoItems) return;

		console.info("Filtering salesHistory with ongoingPoItems", { salesHistory, ongoingPoItems });

		// Create a filtered copy of salesHistory
		let filtered = { ...salesHistory };

		// For each ongoing PO item, subtract its quantity from the sales history
		ongoingPoItems.forEach(poItem => {
			if (poItem.sku && poItem.qty) {
				// Find if this SKU exists in the current sales data
				// Since salesHistory is date-based, we need to reduce quantities proportionally
				// or remove the item entirely if the PO quantity covers all sales
				
				let totalSales = Object.values(filtered).reduce((sum, dailySales) => sum + dailySales, 0);
				let poQty = parseInt(poItem.qty);
				
				if (poQty >= totalSales) {
					// If PO quantity covers all sales, zero out all dates
					Object.keys(filtered).forEach(date => {
						filtered[date] = 0;
					});
				} else {
					// Proportionally reduce sales across all dates
					let reductionRatio = (totalSales - poQty) / totalSales;
					Object.keys(filtered).forEach(date => {
						filtered[date] = Math.round(filtered[date] * reductionRatio);
					});
				}
			}
		});

		console.info("Filtered salesHistory result", filtered);
		setFilteredSalesHistory(filtered);
	}

	let init = async () => {
		props.loading(true)
		
		try {
			// Run all three fetches in parallel
			const [reorderResult, poItemsResult, lastPoResult] = await Promise.all([
				fetchReorderAsync(),
				fetchPoitemsAsync(),
				fetchLastPoForSupplierAsync()
			])
			
			// Handle results
			console.info("reordering_poList", reorderResult);
			props.info(reorderResult)
			setPo(reorderResult.data[0] ?? false)
			
			if(poItemsResult.error) {
				props.info({error: poItemsResult.error})
			} else {
				console.info("getReorderItems", poItemsResult);
				setPoItems(poItemsResult.data.length > 0? poItemsResult.data : []);
			}

			if(lastPoResult.error) {
				props.info({error: lastPoResult.error})
			} else {
				console.info("getLastPoForSupplier", lastPoResult);
				setLastPo(lastPoResult ?? false)
			}
			
			/* console.info("fetchOngoingPoItems", ongoingPoItemsResult.data);
			// ongoingPoItemsResult => [{sku: '123', qty: 100, cost: 10}, {sku: '456', qty: 200, cost: 20}]
			setOngoingPoItems(ongoingPoItemsResult.data) */
			
		} catch (error) {
			console.error("Error in parallel fetch:", error)
			props.info({error: "Failed to load data" + error.message})
		} finally {
			props.loading(false)
		}
	}

	let lockPo = () => {

		fetchApiData("reordering", "setStatusPo", {
			id_po: props.data.id,
			locked: !props.data.locked,
			uid: props.getUser()?.uid
		}, null, (r) => {
			if(r.error) {
				props.info({error: r.error})
			} else {
				props.info({success: `PO ${props.data.locked ? 'unlocked' : 'locked'} successfully`})
				// Refresh the PO list
				if(props.fetchPoList) {
					props.fetchPoList()
				}
			}
		})
	}

	let createUpdatePo = () => {
		const rows = (filteredPoItems || []).filter(item => !item.is_removed && !item.remove_from_next_po);
		const totalQty = rows.reduce((sum, item) => sum + getFinalOrderQuantity(item), 0);
		const totalCost = rows.reduce((sum, item) => sum + getFinalOrderQuantity(item) * (Number(item.cost) || 0), 0);
		const itemCount = rows.filter(item => getFinalOrderQuantity(item) > 0).length;
		if(!itemCount){
			props.info({error: "There are no positive reviewed quantities to place on the PO."});
			return;
		}
		props.modal({
			show: true,
			title: lastPo && !lastPo?.is_committed ? "Confirm PO update" : "Confirm PO creation",
			html: () => <div>
				<p className="mb-2">This will send <strong>{itemCount} SKUs / {totalQty} units</strong> to Finale.</p>
				<p className="mb-0">Estimated product cost: <strong>${roundPrice(totalCost, 2)}</strong>.</p>
			</div>,
			ok: { title: lastPo && !lastPo?.is_committed ? "Update PO" : "Create PO", fnc: (popup, close) => { close(); createUpdatePoConfirmed(); } },
			return: { title: "Cancel" }
		});
	}

	let createUpdatePoConfirmed = () => {
		props.loading(true)
		fetchApiData("reordering", "createPOFromRecommendations", {
			id_supplier: props.parent.match.params.idSupplier,
			options: JSON.stringify({"notes":"PO created from UI"})
		}, null, (r) => {
			props.loading(false)
			if(r.errors) {
				props.info({error: r.errors})
			} else {
				props.info({success: `PO created/updated successfully`})
			}
		})
	}

	// Promisified version of fetchOngoingPoItems
	let fetchOngoingPoItemsAsync = () => {
		return new Promise((resolve, reject) => {
			fetchApiData("reordering", "getPurchaseOrderWithDetail", {
				id_supplier: props.parent.match.params.idSupplier
			}, null, (r) => {
				if (r.error) {
					reject(r.error)
				} else {
					resolve(r)
				}
			})
		})
	}

	let fetchReorder = () => {

		fetchApiData("reordering", "poList", {
			filters: JSON.stringify({
				id_supplier: props.parent.match.params.idSupplier
			})
		}, null, (r) => {
			console.info("reordering_poList", r);
			props.info(r)
			setPo(r.data[0] ?? false)
		})
	}

	// Promisified version of fetchReorder
	let fetchReorderAsync = () => {
		return new Promise((resolve, reject) => {
			fetchApiData("reordering", "poList", {
				filters: JSON.stringify({
					id_supplier: props.parent.match.params.idSupplier
				})
			}, null, (r) => {
				if (r.error) {
					reject(r.error)
				} else {
					resolve(r)
				}
			})
		})
	}
	
	let fetchLastPoForSupplierAsync = () => {
		return new Promise((resolve, reject) => {
			fetchApiData("reordering", "getLastPoForSupplier", {
				id_supplier: props.parent.match.params.idSupplier
			}, null, (r) => {
				if (r.error) {
					reject(r.error)
				} else {
					resolve(r)
				}
			})
		})
	}

	let neverOrderItem = (idProduct) => {
		fetchApiData("reordering", "setReorderRemoved", {
			id_product: idProduct,
			uid: props.getUser()?.uid
		}, null, (r) => {
			console.info("neverOrderItem", r);
			if(r.error) {
				props.info({error: r.error})
			} else {
				props.info({success: `Item ${idProduct} removed from reordering`})
				fetchPoitems()
			}
		})
	}

	let delReorderItemRemoved = (idProduct) => {
		fetchApiData("reordering", "delReorderRemoved", {
			id_product: idProduct
		}, null, (r) => {
			console.info("delReorderItemRemoved", r);
			if(r.error) {
				props.info({error: r.error})
			} else {
				props.info({success: `Item ${idProduct} added back to reordering`})
				fetchPoitems()
			}
		})
	}

	let fetchPoitems = () => {

		fetchApiData("reordering", "getReorderItems", {
			filters: JSON.stringify({
				id_supplier: props.parent.match.params.idSupplier
			})
		}, null, (r) => {
			if(r.error) {
				props.info({error: r.error})
			} else {
				console.info("getReorderItems", r);
				setPoItems(r.data.length > 0? r.data : []);
			}
		})
	}

	// Promisified version of fetchPoitems
	let fetchPoitemsAsync = () => {
		return new Promise((resolve, reject) => {
			fetchApiData("reordering", "getReorderItems", {
				filters: JSON.stringify({
					id_supplier: props.parent.match.params.idSupplier
				})
			}, null, (r) => {
				if (r.error) {
					reject(r.error)
				} else {
					resolve(r)
				}
			})
		})
	}

	let fetchSalesHistory = (idProductList) => {

		fetchApiData("reordering", "getSalesCountPerSkuAndStoreForLastXDays", {
			idProductList: idProductList.join(','),
			desc: false
		}, null, (r) => {
			if(r.error) {
				props.info({error: r.error})
			} else {
				console.info("getSalesCountPerSkuAndStoreForLastXDays", r, r.data, idProductList);
				setSalesHistory(Object.keys(r.data).length > 0 && idProductList.length > 0? r.data[Object.keys(r.data)[0]] : null);
			}
		})
	}

	let modalAssignedTo = () => {
		// Reset modal search when opening modal
		props.modal({
			show: true,
			title: "Po Details",
			options: {
				width: "modal-xl"
			},
			html: () => {
				return 
			},
			exit: (popup, close) => {
				refModalAssignedTo.current = false
				close()
			},
			return: {
				title: "Close",
				fnc: (popup, close) => {
					refModalAssignedTo.current = false
					close()
				}
			}
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	console.info("lastPolastPo", lastPo);

	let getFinaleUrl = () => {
		let orderUrl = lastPo.orderUrl.split("/eio/api/order/");
		return `https://app.finaleinventory.com/eio/sc2/?order/purchase/order/${btoa("/eio/api/order/"+orderUrl[1])}`
	}

	return (
		<div className="w-100">
			<div>
				<button
					className="btn btn-outline-secondary mb-3"
					onClick={() => {
						props.parent.history.push('/Reordering')
					}}
				>
					&larr; Back to reordering list
				</button>
				<h2 className="mb-2">
					{po && po.supplier_name ? (
						<span>PO for <span className="text-primary">{po.supplier_name}</span></span>
					) : (
						<span>PO Details</span>
					)}
				</h2>
				<div className="row">
					<div className="col-12">
						<div className="p-2">
							{/* <button 
								className={`btn ${props.data.locked ? 'btn-secondary' : 'btn-warning'} mb-3`}
								onClick={() => lockPo()}
							>
								{props.data.locked ? 'Unlock PO' : 'Lock PO'}
							</button> */}


							{
								!lastPo? <div className="alert alert-warning" role="alert">
									No PO found for this supplier.
								</div> : ""
							}
							{lastPo && !lastPo?.is_committed? <div className="alert alert-primary" role="alert">
								PO ID: <b>{lastPo.orderId}</b> in Draft mode&nbsp;
								<a
									href={getFinaleUrl()}
									target="_blank"
									rel="noopener noreferrer"
									className="ml-2"
								>
									View in Finale
								</a>
							</div> : lastPo?.is_committed? <div className="alert alert-warning" role="alert">
								This list of items has been committed to a PO.
							</div> : ""}

							{
								<button 
									className={`btn ${props.data.locked ? 'btn-secondary' : 'btn-primary'} mb-3 ml-3`}
									onClick={() => createUpdatePo()}
									disabled={props.loading()}
								>
									{!lastPo? "Create PO" : "Update PO Items"}
								</button>
							}
						</div>
					</div>
				</div>
			</div>
			<div className={"" + ("className" in props? props.className : ' p-2')}>
				<div className="row">
					<div className="col-12">
						<div className="mb-3">
							<input
								type="text"
								className="form-control"
								placeholder="Search by SKU..."
								// value={skuSearch}
								onChange={e => setSkuSearch(e.target.value)}
							/>
						</div>
						<h2>PO Items [{filteredPoItems?.filter(item => !item.is_removed).length}]</h2>
						{filteredPoItems === null ? (
							<div className="alert alert-info">Loading PO items...</div>
						) : filteredPoItems.length === 0 ? (
							<div className="alert alert-warning">No PO items found.</div>
						) : (
							// Filter poItems by SKU search
							(() => {
								const filteredItems = skuSearch.trim() === "" ? filteredPoItems : filteredPoItems.filter(item => item.sku && item.sku.toLowerCase().includes(skuSearch.toLowerCase()));
								return (
								<div className="table-responsive" style={{maxHeight: '70vh'}}>
									<table className="table table-striped table-bordered">
										<thead className="thead-light position-sticky" style={{top: 0, zIndex: 1020, backgroundColor: '#f8f9fa'}}>
											<tr>
												<th className="align-middle text-wrap overflow-auto text-center"><div>SKU</div></th>
												<th className="align-middle text-wrap overflow-auto text-center">EIO ID</th>
												<th className="align-middle text-wrap overflow-auto text-center">Item Cost</th>
												<th className="align-middle text-wrap overflow-auto text-center">Avg Daily Sales</th>
												<th className="align-middle text-wrap overflow-auto text-center">Avg Monthly Sales</th>
											<th className="align-middle text-wrap overflow-auto text-center">Stock Remaining</th>
											<th className="align-middle text-wrap overflow-auto text-center">Net recommendation</th>
											<th className="align-middle text-wrap overflow-auto text-center">Target stock</th>
												<th className="align-middle text-wrap overflow-auto text-center" style={{minWidth: '70px'}}>
													Stock on order
													<i
														className="bi bi-info-circle tooltipInfo ml-1" 
														data-toggle="tooltip" 
														data-placement="bottom" 
														title="Stock on order"
													></i>
												</th>
											<th className="align-middle text-wrap overflow-auto">
												Order increment
													<i
														className="bi bi-info-circle tooltipInfo ml-1" 
														data-toggle="tooltip" 
													data-placement="bottom"
													title="Finale reorder-in-quantity-of. Positive quantities are rounded up to this supplier pack increment."
													></i>
												</th>
												<th style={{maxWidth: '90px'}} className="text-center align-middle">
												<span className="overflow-hidden">
													Final qty<br/>
														<i 
															className="bi bi-info-circle tooltipInfo ml-1" 
															data-toggle="tooltip" 
														data-placement="bottom"
														title="Net recommendation rounded to the supplier order increment. This is the quantity sent to Finale."
														></i>
													</span>
												</th>
											<th className="align-middle text-wrap overflow-auto">
												Review / value
													<i 
														className="bi bi-info-circle tooltipInfo ml-1" 
														data-toggle="tooltip" 
													data-placement="bottom"
													title="Optional reviewed quantity. Zero excludes the item; positive values are rounded to the order increment."
													></i>
												</th>
												<th>Options</th>
												<th>Date Generated</th>
											</tr>
										</thead>
										<tbody>
											{
												filteredItems.filter(item => !item.is_removed).map((item, idx) => {

																let toOrderCalculated = getFinalOrderQuantity(item);
																let hasIncrementRounding = !hasReviewedQuantity(item) && toOrderCalculated !== Number(item.recommended_order || 0);

													// console.info("item_from_filteredItems", item);
													return (
														<React.Fragment key={`${item.id_product}-${idx}_fragment`}>
															<tr key={`${item.id_product}-${idx}_upper`} className={(item.has_ongoing_po && item.recommended_order === 0 ? 'table-success' : '') + (item.remove_from_next_po ? ' table-danger' : '')}>
																<td className="text-center">
																	<a href={`/catalog/${item.sku}`} target="_blank" rel="noopener noreferrer">
																		{item.sku}
																	</a>
																	{item.has_ongoing_po && item.recommended_order === 0 && (
																		<span className="badge badge-success ml-2" title="Fully covered by ongoing PO">
																			✓ Covered
																		</span>
																	)}
																	{
																		item.has_sales_spike ? (
																			<>
																				<br />
																				<span className="badge badge-warning ml-2 p-2" title="Recent sales spike detected">
																					⚡ Spike
																				</span>
																			</>
																		) : ''
																	}
																</td>
																<td className="text-center align-middle">{item.id_product}</td>
																<td className="text-center align-middle">${item.cost}</td>
																<td className="text-center align-middle">{item.avg_daily_sales}</td>
																<td className="text-center align-middle">{item.avg_monthly_sales}</td>
																<td className={`text-center align-middle${!item.qty_remaining ? ' text-danger' : ''}`}>{item.qty_remaining ?? "0"}</td>
																<td className="text-center align-middle">{`${item.recommended_order ?? "0"}`}</td>
																<td className="text-center align-middle">{item.reorder_qty ?? "n/a"}</td>
																<td className="text-center align-middle">{item.qty_on_order ?? "0"}</td>
																<td className="text-center align-middle" /* Order increment */>
																	{item.reorder_in_qty_of || 1}
																</td>
																<td className="text-center align-middle" /* Qty to order */>
																	<span
																		className={
																			"badge " +
																			(
																				(toOrderCalculated) > 0
																					? "badge-danger"
																					: "badge-success"
																			)
																		}
																					title="Final quantity that will be sent to Finale"
																	>
																		{toOrderCalculated}
																	</span>
																</td>
																<td className="text-center align-middle">
																	<span className="qty-display mr-2" style={{marginTop: '0.5rem'}}>
																		{/* item.has_ongoing_po ? (
																			<>
																				<span className="text-muted" style={{textDecoration: 'line-through'}}>
																					{item.original_recommended_order}
																				</span>
																				{' → '}
																				<span className="text-primary font-weight-bold">
																					{item.recommended_order}
																				</span>
																			</>
																		) : */ (
																			toOrderCalculated
																		)}
																					{hasReviewedQuantity(item)? <span className="badge badge-success ml-1">reviewed {item.qty_adjusted}</span> : hasIncrementRounding ? <span className="badge badge-info ml-1">rounded</span> : ''}
																	</span>
																	<button 
																		className={"btn btn-sm tooltipInfo mr-2" + (editQty === item.id ? ' btn-success' : ' btn-primary')}
																		data-toggle="tooltip" 
																		data-placement="top" 
																		title="Edit Order Quantity"
																		onClick={(e) => {
																			if(editQty === item.id){
																				// Save the new quantity
																				fetchApiData("reordering", "setRecommended", {
																					data: JSON.stringify([{
																						id: item.id,
																						qty_adjusted: item.qty_adjusted
																					}]),
																				}, null, (r) => {
																					console.info("setRecommended", r);
																					setEditQty(null);
																				})
																			}else{
																				setEditQty(item.id);
																			}
																		}}
																	>
																		<i className={"bi " + (editQty === item.id ? 'bi-check-square' : 'bi-pencil-square')}></i>
																	</button>
																	{
																		editQty === item.id && (
																			<button className="btn btn-sm btn-warning tooltipInfo mr-2" data-toggle="tooltip" data-placement="top" title="Exit edit mode" onClick={() => {
																				setEditQty(null);
																			}}>
																				<i className="bi bi-x-square"></i>
																			</button>
																		)
																	}
																	<br/>
																	<input
																		type="number"
																		min="0"
																		step="1"
																		className="form-control edit-qty-input"
																		style={{
																			display: editQty === item.id ? 'block' : 'none',
																			marginTop: '0.5rem',
																			width: '80px',
																			margin: '0.5rem auto'
																		}}
																		defaultValue={hasReviewedQuantity(item) ? item.qty_adjusted : item.recommended_order}
																		onChange={(e) => {
																			// Handle quantity change
																			const newQty = parseInt(e.target.value) || 0;
																			// You'll need to implement the state update logic here
																			item.qty_adjusted = newQty;
																			setRefreshView(refreshView+1)
																		}}
																	/>
																	${roundPrice(toOrderCalculated * item.cost, 2)}
																</td>
																<td className="text-center">
																	<div className="align-middle d-flex justify-content-center">

																		<button
																				className="btn btn-sm btn-warning mr-2 centered"
																				onClick={() => {
																					fetchApiData("reordering", "setRecommended", {
																						data: JSON.stringify([{
																							id: item.id,
																							remove_from_next_po: !item.remove_from_next_po
																						}])
																					}, null, (r) => {
																						if(r?.error){
																							props.info({error: r.error});
																							return;
																						}
																						if(r?.errors){
																							props.info({error: r.errors});
																							return;
																						}
																						item.remove_from_next_po = !item.remove_from_next_po;
																						setRefreshView(prev => prev + 1);
																						props.info({success: `${item.sku} skipped for the next PO`});
																					});
																				}}
																			>
																			{item.remove_from_next_po? 'Unskip' : 'Skip'}
																		</button>
																		<button className="btn btn-danger tooltipInfo mr-1" data-toggle="tooltip" data-placement="bottom" title="Never Order This Item, this item will be barred from the reordering process" onClick={() => {
																			neverOrderItem(item.id_product)
																		}}>
																			<i className="bi bi-trash"></i>
																		</button>
																		<button className="btn btn-info tooltipInfo ml-1" data-toggle="tooltip" data-placement="bottom" title="View Sales History" onClick={() => {
																			if(skuSelectedForGraph != item.sku){
																				setSkuSelectedForGraph(item.sku);
																				fetchSalesHistory([item.id_product])
																			}else{
																				setSkuSelectedForGraph(null)
																			}
																		}}>
																			<i className={"bi " + (skuSelectedForGraph == item.sku? 'bi-x bg-danger' : 'bi-graph-up-arrow')}></i>
																		</button>
																	</div>
																</td>
																<td className="text-center align-middle">{item.date_generated ? new Date(item.date_generated).toLocaleDateString() : ''}</td>
															</tr>
															{skuSelectedForGraph === item.sku && (
																<tr key={`${item.id_product}-${idx}_graph`}>
																			<td colSpan="14">
																		<canvas id="ctnChart"></canvas>
																	</td>
																</tr>
															)}
														</React.Fragment>
													);
											})}
											{
												filteredItems.filter(item => item.is_removed).map((item, idx) => (
													<tr key={`${item.id_product}-${idx}_lower`}>
														<td>
															<del><a href={`/catalog/${item.sku}`} target="_blank" rel="noopener noreferrer">
																{item.sku}
															</a></del>
														</td>
														<td className="text-center">{item.id}</td>
													<td className="text-center">${item.cost}</td>
													<td className="text-center"><del>{item.avg_daily_sales}</del></td>
													<td className="text-center"><del>{item.avg_monthly_sales}</del></td>
													<td className="text-center"><del>{item.qty_remaining}</del></td>
													<td className="text-center"><del>{item.recommended_order}</del></td>
													<td className="text-center">
														<del>{item.reorder_qty}</del>
													</td>
													<td className="text-center"><del>{item.qty_on_order ?? "0"}</del></td>
													<td className="text-center"><del>{item.reorder_in_qty_of || 1}</del></td>
													<td className="text-center"><del>{getFinalOrderQuantity(item)}</del></td>
													<td className="text-center"><del>${roundPrice(getFinalOrderQuantity(item) * Number(item.cost || 0), 2)}</del></td>
													<td className="text-center">
															<button className="btn btn-warning tooltipInfo" data-toggle="tooltip" data-placement="top" title="Place back the item in the reordering process" onClick={() => {
																delReorderItemRemoved(item.id_product)
															}}>
																<i className="bi bi-arrow-counterclockwise"></i>
															</button>
													</td>
													<td className="text-center">{item.date_generated ? new Date(item.date_generated).toLocaleDateString() : ''}</td>
													</tr>
												))
											}
										</tbody>
										<tfoot>
											<tr>
												<th colSpan="3" className="text-right">Total</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.avg_daily_sales || 0), 0).toFixed(2)}</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.avg_monthly_sales || 0), 0).toFixed(2)}</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.qty_remaining || 0), 0)}</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.recommended_order || 0), 0)}</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.reorder_qty || 0), 0)}</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + Number(item.qty_on_order || 0), 0)}</th>
												<th className="text-center">—</th>
												<th className="text-center">{filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + getFinalOrderQuantity(item), 0)}</th>
												<th className="text-center">${roundPrice(filteredItems.filter(item => !item.is_removed && !item.remove_from_next_po).reduce((sum, item) => sum + getFinalOrderQuantity(item) * Number(item.cost || 0), 0), 2)}</th>
												<th colSpan="2"></th>
											</tr>
										</tfoot>
									</table>
								</div>
								)
							})()
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
